module.exports = __webpack_public_path__ + "static/media/mira_decision_browsing.c3f7069b.png";